import { render, staticRenderFns } from "./slider-component.vue?vue&type=template&id=1c44edb6&scoped=true"
import script from "./slider-component.vue?vue&type=script&lang=js"
export * from "./slider-component.vue?vue&type=script&lang=js"
import style0 from "./slider-component.vue?vue&type=style&index=0&id=1c44edb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c44edb6",
  null
  
)

export default component.exports